"use strict";

// 全局功能开关
function GlobalStatus() {
    GetGrayStatus(); // 全站变灰状态
    // 是否闭站
}

function GetGrayStatus() {
    var grayapi = "http://search.edu.cn.54.edudev.eol.com.cn/globalvar/get";
    $.ajax({
        url: grayapi,
        type: "get",
        dataType: 'json',
        success: function success(data) {
            if (data.code === 1) {
                $('html').addClass('begray');
            } else if (data.code === 0) {
                console.log("未开启变灰功能");
            } else {
                console.log("接口异常");
            }
        }
    });
}

// 手机版菜单效果
$(document).ready(function () {
    $('#menu-btn').click(function () {
        $('#header .nav').toggleClass('active');
        $('#header .search').toggle();
    });
    $('#menus>li>i').click(function () {
        $(this).siblings('.sub-menu').toggle();
        $(this).parent('.menu').siblings().children('.sub-menu').hide();
    });
});